export default {
  activeInbox: {
    inboxId: null,
    subInbox: null,
  },
  currentAssignment: 'all',
  currentFolder: 'open',
  stats: {
    businesses: [],
  },
};
